<template>
  <div class="download-dialog common-dialog">
    <div class="dialog-content">
      <div class="text-content">
         <p class="text text-app">Play the podcast on Podbean</p>
        <p class="title">{{ setting.podcastTitle }}</p>
      </div>
      <div class="app-download">
        <a
          class="download-app-btn"
          :href="episode.playStopShareLink"
          target="_blank"
        >
          <icon-small-podbean-logo></icon-small-podbean-logo>
          <span class="line"></span>
          <span class="btn-text">Listen on <br> Podbean app</span>
        </a>

      </div>
    </div>
     <a v-if="setting.pbad" class="podbean-logo"
     href="http://www.podbean.com?utm_campaign=pb_web_audio_player&utm_medium=app_download&utm_source=pb_web_player"
     target="_blank">
     <icon-podbean-logo></icon-podbean-logo>
    </a>
    <button class="close" @click="close">
      <icon-close />
    </button>
  </div>
</template>

<script>
import { MUTATION_UPDATE } from "@/store/mutations";
import IconClose from "./icons/IconClose";
import { mapGetters, mapState } from "vuex";
import IconPodbeanLogo from "@/components/icons/IconPodbeanLogo";
import IconSmallPodbeanLogo from "./icons/IconSmallPodbeanLogo";

export default {
  name: "AppDownloadSquare",
  components: {IconSmallPodbeanLogo, IconPodbeanLogo, IconClose },
  computed: {
    ...mapGetters(["episode"]),
    ...mapState(["setting"])
  },
  methods: {
    close() {
      this.$store.commit(MUTATION_UPDATE, ["showAppDownloadStatus", 2]);
    }
  }
};
</script>

<style lang="scss" scoped>
.download-dialog {
  position: absolute;
  top: 0;
  bottom: 0;
  background: #f6f6f6;
  width: 100%;
  z-index: 99;
  display: flex;
  flex-direction: column;
  .dialog-content {
    margin: auto;
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    height: 130px;
    text-align: center;
  }
  .text-content{
    flex-shrink: 0;
  }
  .user-pb-logo{
    flex-shrink: 1;
    .pb-logo {
      text-align: center;
      width: 60vw;
      height: 60vh;
      margin: 0 auto;
      border-radius: 50%;
    }
  }
  .app-download {
    margin-top: 8px;
    flex-shrink: 0;
    a {
      &:first-child {
        margin-right: 5px;
      }
    }
    img {
      width: 150px;
    }
  }
  p {
    font-size: 16px;
    margin-bottom: 0;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  .title{
    font-size: 22px;
    font-weight: 600;
    padding-bottom: 5px;
    padding-left: 15px;
    padding-right: 15px;
  }
}
</style>
